
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftBottom75 as ObiThreewayAcuatorGenericInleftBottom75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-bottom-75.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftBottom75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-bottom-75',
   elementClass: ObiThreewayAcuatorGenericInleftBottom75Element,
   events: {
     
   }
  });
 
 